import { Button, Tooltip } from "@/components/ui";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { BookOpen } from "lucide-react";
import { useState } from "react";
import { FormularyModal } from "./FormularyModal";

export interface FormularyButtonProps {
  ndc: string;
  medicationName?: string;
}

export const FormularyButton = ({
  ndc,
  medicationName,
}: FormularyButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: isFormularyEnabled } = useConfigCatFeatureFlag(
    "emr-surescripts-formulary",
  );

  if (!isFormularyEnabled) return null;

  return (
    <>
      <Tooltip
        tooltipContentText="View Formulary"
        side="bottom"
        triggerClassName="flex items-center"
      >
        <Button
          variant="icon"
          className="m-0 p-0"
          onClick={() => setIsOpen(true)}
          aria-label="View formulary"
        >
          <BookOpen className="stroke-link h-4 w-4" />
        </Button>
      </Tooltip>
      <FormularyModal
        open={isOpen}
        onOpenChange={setIsOpen}
        ndc={ndc}
        medicationName={medicationName}
      />
    </>
  );
};
